// extracted by mini-css-extract-plugin
module.exports = {"columnOverrides":"b37136CkXbToNSriDgBcRw==","container":"EKErjRUqzFrYm39x5988kw==","textContainer":"IQBndb8dSMJsaQbp641eBQ==","brandImage":"Z+RUK9bsZ9iCudqfGlYtGw=="};